import { ITheme } from './theme'

export const FLIX_THEME: ITheme = {}
